import {
  FilterBuilder,
  type ActiveFilterChip,
  type FilterBuilderOption,
} from '@/admin/components/common/filter-builder';
import { Card, CardContent, CardTitle } from '@/admin/components/ui/card';

export function ChatFilters({
  options,
  activeFilters,
  onAdd,
  onRemove,
  onClear,
}: {
  options: FilterBuilderOption[];
  activeFilters: ActiveFilterChip[];
  onAdd: (key: string, value: string) => void;
  onRemove: (key: string) => void;
  onClear: () => void;
}) {
  return (
    <Card className="py-0">
      <CardContent className="flex flex-wrap items-center gap-3 p-3">
        <CardTitle className="shrink-0 text-base">Filters</CardTitle>
        <div className="min-w-0 flex-1">
          <FilterBuilder
            options={options}
            activeFilters={activeFilters}
            onAdd={onAdd}
            onRemove={onRemove}
            onClear={onClear}
          />
        </div>
      </CardContent>
    </Card>
  );
}
